// Key values can be found in https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
export const KeyboardEventKeys = {
	ALT: {
		key: 'Alt',
		which: 18,
	},
	BACKSPACE: {
		key: 'Backspace',
		which: 8,
	},
	CTRL: {
		key: 'Control',
		which: 17,
	},
	DELETE: {
		key: 'Delete',
		which: 46,
	},
	DOWN: {
		key: 'ArrowDown',
		which: 40,
	},
	END: {
		key: 'End',
		which: 35,
	},
	ENTER: {
		key: 'Enter',
		which: 13,
	},
	ESCAPE: {
		key: 'Escape',
		which: 27,
	},
	HOME: {
		key: 'Home',
		which: 36,
	},
	INSERT: {
		key: 'Insert',
		which: 45,
	},
	LEFT: {
		key: 'ArrowLeft',
		which: 37,
	},
	/**
	 * Command key on OSX, WinKey on Windows.
	 * On windows, the "Windows" home button is considered
	 * the "meta" key, but many browsers don't register that event
	 * as it is intercepted by the operating system. If referencing
	 * this key, you should also consider allowing "ctrl" key.
	 */
	META: {
		key: 'Meta',
		which: 91,
	},
	PAGEDOWN: {
		key: 'PageDown',
		which: 34,
	},
	PAGEUP: {
		key: 'PageUp',
		which: 33,
	},
	RIGHT: {
		key: 'ArrowRight',
		which: 39,
	},
	SPACE: {
		key: ' ',
		which: 32,
	},
	SHIFT: {
		key: 'Shift',
		which: 16,
	},
	TAB: {
		key: 'Tab',
		which: 9,
	},
	UP: {
		key: 'ArrowUp',
		which: 38,
	},
};
